import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 8px 12px 0;
  width: 100%;
  overflow: hidden;
`;

export const EmbedWrapper = styled.div`
  flex: 1;
  width: 100%;
  margin-top: 8px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;

  iframe {
    width: 100% !important;
    height: 100% !important;
    border: none;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
`;
